import { Serializer } from '@teem/generic/serializer';
import { Resource } from '@teem/generic/resource';

export class UserSerializer implements Serializer {
	fromJson(json: any): User {
		let user = new User(json);
		return user;
	}

	toJson(user: User): any {
		return user;
	}
}

export class User implements Resource {
	public id: string;
	public uuid: string;
	public first_name: string;
	public last_name: string;
	public email: string;
	public phone: number;
	public business_name: string;
	public user_type: string;

	constructor(input?: any) {
		if (input) {
			Object.assign(this, input);			
		}
	}
}
